import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {PricingOptions} from "../common/PricingOptions";

export const Pricing = () => {
    const {t} = useTranslation();

    return (
        <Container className="py-5">
            <h2 className="text-center mb-4">{t("pages.pricing.title")}</h2>
            <p className="text-center text-muted mb-5">{t("pages.pricing.subtitle")}</p>

            <PricingOptions></PricingOptions>

            <Row className="my-5">
                <Col>
                    <h3 className="text-center mb-4">{t("pages.pricing.comparisonTitle")}</h3>
                    <div className="table-responsive">
                        <table className="table table-bordered text-center">
                            <thead>
                            <tr>
                                <th>{t("pages.pricing.features.feature")}</th>
                                <th>{t("pages.pricing.basic.title")}</th>
                                <th>{t("pages.pricing.pro.title")}</th>
                                <th>{t("pages.pricing.enterprise.title")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{t("pages.pricing.features.users")}</td>
                                <td>1</td>
                                <td>5</td>
                                <td>Unlimited</td>
                            </tr>
                            <tr>
                                <td>{t("pages.pricing.features.support")}</td>
                                <td>-</td>
                                <td>{t("pages.pricing.features.emailSupport")}</td>
                                <td>{t("pages.pricing.features.prioritySupport")}</td>
                            </tr>
                            <tr>
                                <td>{t("pages.pricing.features.aiInsights")}</td>
                                <td>-</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>

            <Row className="my-5">
                <Col>
                    <h3 className="text-center mb-4">{t("pages.pricing.testimonials.title")}</h3>
                    <Row>
                        <Col md={4}>
                            <blockquote className="blockquote">
                                <p>{t("pages.pricing.testimonials.quote1")}</p>
                                <footer className="blockquote-footer">Jane Doe, CTO at TechCorp</footer>
                            </blockquote>
                        </Col>
                        <Col md={4}>
                            <blockquote className="blockquote">
                                <p>{t("pages.pricing.testimonials.quote2")}</p>
                                <footer className="blockquote-footer">John Smith, Freelancer</footer>
                            </blockquote>
                        </Col>
                        <Col md={4}>
                            <blockquote className="blockquote">
                                <p>{t("pages.pricing.testimonials.quote3")}</p>
                                <footer className="blockquote-footer">Sara Khan, Product Manager</footer>
                            </blockquote>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="my-5">
                <Col lg={{span: 8, offset: 2}}>
                    <h3 className="text-center mb-4">{t("pages.pricing.faq.title")}</h3>
                    <div className="accordion" id="faqAccordion">
                        {[1, 2, 3].map((id) => (
                            <div className="accordion-item" key={id}>
                                <h2 className="accordion-header" id={`heading${id}`}>
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${id}`}
                                        aria-expanded="false"
                                        aria-controls={`collapse${id}`}
                                    >
                                        {t(`pages.pricing.faq.q${id}`)}
                                    </button>
                                </h2>
                                <div
                                    id={`collapse${id}`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={`heading${id}`}
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t(`pages.pricing.faq.a${id}`)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
